// src/Pages/Usuario/Agenda/components/Paso.jsx
export default function Paso({ n, label, activo, completo }) {
  return (
    <div className="flex items-center gap-2">
      <span
        className={`flex h-7 w-7 items-center justify-center rounded-full text-xs font-bold shadow-sm
      ${
        completo
          ? "bg-emerald-500 text-white"
          : activo
          ? "bg-[#0099D4] text-white"
          : "bg-gray-200 text-gray-600"
      }`}
      >
        {n}
      </span>
      <span
        className={`text-sm ${
          completo
            ? "text-emerald-700"
            : activo
            ? "text-[#1f43b8]"
            : "text-[#4B5563]"
        }`}
      >
        {label}
      </span>
    </div>
  );
}
